// extracted by mini-css-extract-plugin
export var dataCell = "_q5-2";
export var dataRow = "_q5-0";
export var headerRow = "_q5-1";